module.exports = __webpack_public_path__ + "img/icon-qrcode-border-bl.0f7bbad0.svg";